import { salesApiRoutes as routes } from './routes';
export function getSalesApiV1(httpClient) {
    return {
        masterData: {
            itemProfiles: {
                getForSite: siteId => httpClient.get(routes.masterData.itemProfiles.getForSite(siteId)),
                getForGiftShop: () => httpClient.get(routes.masterData.itemProfiles.getForGiftShop())
            },
            items: {
                getByHopkForSite: (siteId, itemHopk) => httpClient.get(routes.masterData.items.getByHopkForSite(siteId, itemHopk))
            },
            subscriptionBillingOptions: {
                getAll: () => httpClient.get(routes.masterData.subscriptionBillingOptions.getAll())
            },
            ticketPrices: {
                getForShowtime: showtimeId => httpClient.get(routes.masterData.ticketPrices.getForShowtime(showtimeId))
            }
        },
        availability: {
            itemAvailability: {
                getForSite: siteId => httpClient.get(routes.availability.itemAvailability.getForSite(siteId)),
                getForGiftShop: () => httpClient.get(routes.availability.itemAvailability.getForGiftShop())
            },
            discountAvailability: {
                getForSite: siteId => httpClient.get(routes.availability.discountAvailability.getForSite(siteId)),
                getForShowtime: showtimeId => httpClient.get(routes.availability.discountAvailability.getForShowtime(showtimeId))
            }
        }
    };
}
//# sourceMappingURL=get-sales-api.js.map